import { lazy } from 'react';
import ROUTES from '../constants/routes';

const Routes = [
    {
        name: "Login",
        path: ROUTES.LOGIN,
        component: lazy(() =>
            import("../components/login")
        ),
        requireAuthentication: false,
    },
    {
        name: "Main",
        path: ROUTES.MAIN,
        component: lazy(() =>
            import("../components/main")
        ),
        requireAuthentication: true,
    },
    {
        name: "REDEEM",
        path: ROUTES.REDEEM,
        component: lazy(() =>
            import("../components/redeem")
        ),
        requireAuthentication: true,
    },
];

export default Routes;
